import React from 'react'

export default function RelatedTag(props) {
  function onTagClick() {
    dataLayer.push({
      event: 'CustomEvent',
      eventCategory: props.search_page,
      eventAction: props.top_links,
      eventLabel: props.tag,
    })
  }

  const capitalizedTag = props.tag[0].toUpperCase() + props.tag.substring(1)

  return (
    <li className="list__item" onClick={onTagClick}>
      <a href={`${props.base_url}${props.tag}`}>
        {capitalizedTag}
      </a>
      <span className="tag-count">
        {` (${props.model_count})`}
      </span>
    </li>
  )
}
